import React, { useEffect } from "react";
import { Carousel } from "bootstrap";

const HeroSlider = () => {

  useEffect(() => {
    const element = document.querySelector("#heroCarousel");
    if (element) {
      new Carousel(element, {
        interval: 5000,
        ride: "carousel",
        pause: false,
        wrap: true,
      });
    }
  }, []);

  return (
    <section className="hero-section">
      <div
        id="heroCarousel"
        className="carousel slide carousel-fade"
      >
        <div className="carousel-inner">

          {/* SLIDE 1 */}
          <div className="carousel-item active slide-1">
            <div className="hero-overlay">
              <div className="container">
                <h1>
                  Welcome to <span>Goodweel Crop Care</span>
                </h1>
                <p>
                  Experience Built on Trust, Backed by Technology.
                  Strengthening Indian agriculture through modern science
                  and innovation.
                </p>
                <a href="/about" className="hero-btn">
                  Explore Our Solutions
                </a>
              </div>
            </div>
          </div>

          {/* SLIDE 2 */}
          <div className="carousel-item slide-2">
            <div className="hero-overlay">
              <div className="container">
                <h1>
                  10+ Years of <span>Agricultural Excellence</span>
                </h1>
                <p>
                  Deep understanding of Indian farming conditions with
                  300+ quality products and strong distribution network.
                </p>
                <a href="/about" className="hero-btn">
                  Our Strengths
                </a>
              </div>
            </div>
          </div>

          {/* SLIDE 3 */}
          <div className="carousel-item slide-3">
            <div className="hero-overlay">
              <div className="container">
                <h1>
                  Complete <span>Crop Protection</span>
                </h1>
                <p>
                  Insecticides, Fungicides, Herbicides, Fertilizers and
                  eco-friendly formulations for healthier crops.
                </p>
                <a href="/products" className="hero-btn">
                  View Products
                </a>
              </div>
            </div>
          </div>

          {/* SLIDE 4 */}
          <div className="carousel-item slide-4">
            <div className="hero-overlay">
              <div className="container">
                <h1>
                  Committed to <span>Sustainable Farming</span>
                </h1>
                <p>
                  Smart, sustainable and profitable farming while
                  protecting soil, water and environment.
                </p>
                <a href="/about" className="hero-btn">
                  Our Vision
                </a>
              </div>
            </div>
          </div>

        </div>

        {/* CONTROLS */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#heroCarousel"
          data-bs-slide="prev"
        >
          <span></span>
        </button>

        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#heroCarousel"
          data-bs-slide="next"
        >
          <span></span>
        </button>
      </div>
    </section>
  );
};

export default HeroSlider;
